export default {
    churchAppAgreementModal: {
        title: `Before you continue...!`,
        description: `In order to offer a custom Church App to your congregation, you will be <span class="font-bold">required to allow members to add themselves</span> to your member database and create member profiles that will be reflected within Breeze.`
    }
}
